import { emailRegex } from "@oefr/utils/regex"
import { z } from "zod"

export const PmaxSummaryEmailSchema = z.object({
    email: z.string({ error: "Email requis" }).trim().regex(emailRegex, "Email invalide"),
})
